import { FineAmountService } from './fine-amounts/fine-amounts.service';
import { RatePackageListComponent } from './rate-packages/rate-package-list/rate-package-list.component';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './inventory-management.component.html',
  styleUrls: ['./inventory-management.component.css']
})
export class InventoryManagementComponent implements OnInit, OnDestroy {
  searchText: string;
  selectedIndex: number;
  mode: string;
  private routerSubscription: Subscription;

  @ViewChild(RatePackageListComponent, {static: true}) ratePackageListComponent: RatePackageListComponent;


  constructor(private router: Router) { }

  ngOnInit() {
    this.syncFromUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  switchTab(evt: number) {
    this.selectedIndex = evt;
    this.navigateToTab(evt);
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    if (this.ratePackageListComponent && tabChangeEvent.tab.textLabel === 'Rate Packages') {
      this.ratePackageListComponent.reloadRatePackageDetail();
    }
  }

  public onTabIndexChange(index: number): void {
    this.navigateToTab(index);
  }

  private navigateToTab(index: number): void {
    let targetUrl: string;

    if (index === 0) {
      targetUrl = '/inventorymanagement/spaces';
    } else if (index === 1) {
      targetUrl = '/inventorymanagement/meters';
    } else if (index === 2) {
      targetUrl = '/inventorymanagement/blocks';
    } else if (index === 3) {
      this.mode = 'list';
      targetUrl = '/inventorymanagement/ratepackages';
    }

    if (targetUrl && this.router.url !== targetUrl) {
      this.router.navigateByUrl(targetUrl);
    }
  }

  private syncFromUrl(url: string): void {
    this.mode = 'list';

    if (url.includes('inventorymanagement/spaces')) {
      this.selectedIndex = 0;
    } else if (url.includes('inventorymanagement/meters')) {
      this.selectedIndex = 1;
    } else if (url.includes('inventorymanagement/blocks')) {
      this.selectedIndex = 2;
    } else if (url.includes('inventorymanagement/ratepackages')) {
      this.selectedIndex = 3;

      if (url.includes('inventorymanagement/ratepackages/create')) {
        this.mode = 'create';
      } else {
        this.mode = 'list';
      }
    } else {
      this.selectedIndex = 0;
    }
  }
}
